import React from "react";
import { observer } from "mobx-react";

import PopupTemplates from "./components/PopupTemplates";

import { useStore } from "../../connect";

const Popups = () => {
  const store = useStore();

  const handleClose = (popup) => {
    store.popupController.handlePopupClose(popup);
  };

  const handleBottomLeftClose = () => {
    handleClose(store.popupController.bottomLeftPopup);
  };

  const handleCenterClose = () => {
    handleClose(store.popupController.centerPopup);
  };

  const handleBottomRightClose = () => {
    handleClose(store.popupController.bottomRightPopup);
  };

  const handleTopRightClose = () => {
    handleClose(store.popupController.topRightPopup);
  };

  const handleTopLeftClose = () => {
    handleClose(store.popupController.topLeftPopup);
  };

  return (
    <>
      {!!store.popupController.bottomLeftPopup && (
        <PopupTemplates
          position="bottomLeft"
          popupData={store.popupController.bottomLeftPopup}
          onClose={handleBottomLeftClose}
        />
      )}
      {!!store.popupController.centerPopup && (
        <PopupTemplates
          position="center"
          popupData={store.popupController.centerPopup}
          onClose={handleCenterClose}
        />
      )}
      {!!store.popupController.bottomRightPopup && (
        <PopupTemplates
          position="bottomRight"
          popupData={store.popupController.bottomRightPopup}
          onClose={handleBottomRightClose}
        />
      )}
      {!!store.popupController.topRightPopup && (
        <PopupTemplates
          position="topRight"
          popupData={store.popupController.topRightPopup}
          onClose={handleTopRightClose}
        />
      )}
      {!!store.popupController.topLeftPopup && (
        <PopupTemplates
          position="topLeft"
          popupData={store.popupController.topLeftPopup}
          onClose={handleTopLeftClose}
        />
      )}
    </>
  );
};

export default observer(Popups);
